const themes = {
  light: {
    default: {
      primary: '#1773ce',
      primaryText: '#fff',
      mainBackground: '#fff',
      subBackground: '#f8f8f8',
      accent1: '#a76801',
      accent2: '#018925',
      accent3: '#4d4d4d',
      accentText: '#fff',
      grey: '#4d4d4d',
      greyText: '#fff',
      profileText: '#000',
      anchorText: '#115599',
      error: '#f44336'
    },
    protanopia: {
      primary: '#00e5c4',
      primaryText: '#000',
      mainBackground: '#fff',
      subBackground: '#f8f8f8',
      accent1: '#1592d2',
      accent2: '#62de02',
      accent3: '#b2b2b2',
      accentText: '#000',
      grey: '#4d4d4d',
      greyText: '#fff',
      profileText: '#000',
      anchorText: '#115599',
      error: '#f44336'
    },
    deuteranopia: {
      primary: '#e8a8a6',
      primaryText: '#000',
      mainBackground: '#fff',
      subBackground: '#f8f8f8',
      accent1: '#40b6da',
      accent2: '#62de02',
      accent3: '#b2b2b2',
      accentText: '#000',
      grey: '#4d4d4d',
      greyText: '#fff',
      profileText: '#000',
      anchorText: '#115599',
      error: '#f44336'
    },
    tritanopia: {
      primary: '#cad0ff',
      primaryText: '#000',
      mainBackground: '#fff',
      subBackground: '#f8f8f8',
      accent1: '#febcbe',
      accent2: '#ff4e4c',
      accent3: '#b2b2b2',
      accentText: '#000',
      grey: '#4d4d4d',
      greyText: '#fff',
      profileText: '#000',
      anchorText: '#115599',
      error: '#f44336'
    }
  },
  dark: {
    default: {
      primary: '#186acd',
      primaryText: '#fff',
      mainBackground: '#323232',
      subBackground: '#1a1a1a',
      accent1: '#a66900',
      accent2: '#008a23',
      accent3: '#4d4d4d',
      accentText: '#fff',
      grey: '#b2b2b2',
      greyText: '#000',
      profileText: '#fff',
      anchorText: '#60a8ff',
      error: '#f44336'
    },
    protanopia: {
      primary: '#00e5c4',
      primaryText: '#000',
      mainBackground: '#323232',
      subBackground: '#1a1a1a',
      accent1: '#7287ca',
      accent2: '#62de02',
      accent3: '#e5e5e5',
      accentText: '#000',
      grey: '#b2b2b2',
      greyText: '#000',
      profileText: '#fff',
      anchorText: '#60a8ff',
      error: '#f44336'
    },
    deuteranopia: {
      primary: '#e8a8a6',
      primaryText: '#000',
      mainBackground: '#323232',
      subBackground: '#1a1a1a',
      accent1: '#3db8da',
      accent2: '#62de01',
      accent3: '#e5e5e5',
      accentText: '#000',
      grey: '#b2b2b2',
      greyText: '#000',
      profileText: '#fff',
      anchorText: '#60a8ff',
      error: '#f44336'
    },
    tritanopia: {
      primary: '#cad0ff',
      primaryText: '#000',
      mainBackground: '#323232',
      subBackground: '#1a1a1a',
      accent1: '#febcbe',
      accent2: '#ff4e4e',
      accent3: '#e5e5e5',
      accentText: '#000',
      grey: '#b2b2b2',
      greyText: '#000',
      profileText: '#fff',
      anchorText: '#60a8ff',
      error: '#f44336'
    }
  }
}

export const getTheme = () => {
  return themes[getCurrentMainThemeName()][getCurrentSubThemeName()]
}

export const setMainTheme = (themeName) => {
  localStorage.setItem('main-theme', themeName)
  return getTheme()
}

export const setSubTheme = (themeName) => {
  localStorage.setItem('sub-theme', themeName)
  window.dispatchEvent(new CustomEvent('sub-theme-localstorage-changed', {
    detail: {
      storage: localStorage.getItem('sub-theme')
    }
  }))
  return getTheme()
}

export const setTextSizes = (textSize) => {
  const formattedSize = `${textSize}-text`
  localStorage.setItem('text-size', formattedSize)
  return formattedSize
}

export const getCurrentMainThemeName = () => localStorage.getItem('main-theme') || 'light'

export const getCurrentSubThemeName = () => localStorage.getItem('sub-theme') || 'default'

export const getCurrentTextSize = () => localStorage.getItem('text-size') || 'medium-text'

export default themes



// WEBPACK FOOTER //
// ./src/utils/theme.js